window.SiteSelector = {
    opts: {
        cookieName: 'site-default',
        cookieExpire: 7,
        cookieDomain: '',
        cookieGlobalValue: 'global',
        cDismissParamName: 's', // Query parameter name to use to dismiss site-selector
        openSelectorClass: 'site-selector-expanded',
        langExpandClass: 'lang-expanded',
        initDelay: 500,
		comLinkSelectors:
			'a[href*="hoyavision.northeurope.cloudapp.azure.com"], a[href*="www.hoyavision.com"]',
        ipCountryUrl: null,
    },

    init: function () {
        var self = this,
			forceOpenSelector =
				window.Helpers.getUrlParamByName('site-selector') == 1 ? true : false;

        self.siteSelectorElement = $('#site-selector');

		self.hideOnPageLoad = self.siteSelectorElement.hasClass(
			'hide-on-page-load'
		);

        // Debug: Set ?clearcookies=1 to clear cookies
        if (window.Helpers.getUrlParamByName('clearcookies') == 1) {
            Cookies.remove(self.opts.cookieName);
        }

        // Check if Dismiss query parameter has been set, if yes, save the cookie.
        // This is used to tell HubSpot page to stfu...
        if (window.Helpers.getUrlParamByName(self.opts.cDismissParamName) == 1) {
            self.setCookie();
        }

        // Create listeners
        $(document).bind('hoya:openedNav', function () {
            self.closeSelector();
        });
        $(document).bind('hoya:openedMobileNav', function () { });

        // Bind events
        if ($('[href*="#language-selector"]').length && self.siteSelectorElement.length) {
            // Open site selector
            $('[href*="#language-selector"]').on('click', function (e) {
                //e.preventDefault();
                document.querySelectorAll
                if ($('body').hasClass(self.opts.openSelectorClass)) {
                    self.closeSelector();
                } else {
                    self.openSelector();
                }
                return false;
            });

            // Close site selector
            $('.close-site-selector, .hamburger.active').on('click', function (e) {
                let hamburger = document.querySelector('[data-js="hamburger"]');
                let mobileMenu = document.querySelector('[data-js="mobilemenu"]');
                mobileMenu.classList.remove('active');
                hamburger.classList.remove('active');
                self.closeSelector();
                e.preventDefault();
            });

            // If user clicked on a link containing .set-global-site, save cookie
            // and redirect or close down selector
            $('.set-global-site').on('click', function (e) {
                if (!window.Helpers.inHubSpotPage()) {
                    self.setCookie();
                }
                // Clear the preferredLanguage cookie so the global site is not auto-redirected
                self.updatePreferredLanguageCookie(null);
            });

            // If user clicked a country link that points to global website (no local version exists)
            $('.region-block__country .country__wrap a').on('click', function (e) {
                if ($(this).attr('href')) {
                    var src = $(this)
                        .attr('href')
                        .slice(0, $(this).attr('href').length - 1);
                    var host = window.location.protocol + '//' + window.location.hostname;

                    if (!window.Helpers.inHubSpotPage() && src === host) {
                        self.setCookie();
                    }

                    // Update preferredLanguage cookie to match the selected country
                    var lang = self.getLanguageFromHref($(this).attr('href'));
                    self.updatePreferredLanguageCookie(lang);
                }
            });
            $('.region-block__country--multi-lang li a').on('click', function (e) {
                if ($(this).attr('href')) {
                    var src = $(this)
                        .attr('href')
                        .slice(0, $(this).attr('href').length - 1);
                    var host = window.location.protocol + '//' + window.location.hostname;

                    if (!window.Helpers.inHubSpotPage() && src === host) {
                        self.setCookie();
                    }

                    // Update preferredLanguage cookie to match the selected country
                    var lang = self.getLanguageFromHref($(this).attr('href'));
                    self.updatePreferredLanguageCookie(lang);
                }
            });

            // Init multi language dropdowns
            $('.region-block__country--multi-lang').each(function () {
                var $parent = $(this);

                $parent.find('> div > a').on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    if ($parent.hasClass(self.opts.langExpandClass)) {
                        self.collapseLangNav($parent);
                    } else {
                        self.expandLangNav($parent);
                    }
                    return false;
                });
            });

            // Enable ESC key
            $(document).keyup(function (e) {
                if (e.keyCode === 27) {
                    if ($('body').hasClass(self.opts.openSelectorClass)) {
                        self.closeSelector();
                    }
                }
            });

            //
            // If user hasn't set the global site as default, show the site selector
            // on page initialization. Only show if on global site and not if in HubSpot page
            //
            //if (!self.hideOnPageLoad && !window.Helpers.inHubSpotPage() && (self.cookieNotSet() || forceOpenSelector)) {
            //    setTimeout(function () {
            //        self.openSelector();
            //    }, self.opts.initDelay)
            //}

            self.updateNavLinks();
            var globalImageContainer = $('.global-image-container .global-image');
            if (globalImageContainer.length) {
                var src = globalImageContainer.data('src'),
                    alt = globalImageContainer.data('alt');

                src = src.indexOf('?') === 0 ? '' : src;

                if (src) {
                    globalImageContainer.html(
                        '<div class="img-placeholder" style="background-image: url(' +
                        src +
                        ');"><img src="' +
                        src +
                        '" alt="' +
                        alt +
                        '"/></div>'
                    );
                    window.Helpers.onImagesLoaded(globalImageContainer).then(() => {
                        globalImageContainer.addClass('loaded');
                    });
                } else {
                    // No image src
                    globalImageContainer.html('<div class="img-placeholder"></div>');
                }
            }
        }
        else if (self.siteSelectorElement.length)
        {
            // Init multi language dropdowns
            $('.region-block__country--multi-lang').each(function () {
                var $parent = $(this);

                $parent.find('> div > a').on('click', function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    if ($parent.hasClass(self.opts.langExpandClass)) {
                        self.collapseLangNav($parent);
                    } else {
                        self.expandLangNav($parent);
                    }
                    return false;
                });
            });
        }
    },

    exists: function () {
        return this.siteSelectorElement && this.siteSelectorElement.length;
    },

    cookieNotSet: function () {
		return (
			!Cookies.get(this.opts.cookieName) ||
			Cookies.get(this.opts.cookieName) !==
				this.opts.cookieGlobalValue
		);
    },

    cookieIsSet: function () {
		return this.cookieNotSet();
    },

    setCookie: function () {
        // Set "site default" cookie to global value
        Cookies.set(this.opts.cookieName, this.opts.cookieGlobalValue, {
            expires: this.opts.cookieExpire,
			domain: this.opts.cookieDomain,
        });
    },

    updatePreferredLanguageCookie: function (language) {
        if (!window.preferredLanguageCookieName) return;

        if (language) {
            // Only set the cookie if OneTrust consent has been given for functional cookies
            if (typeof window.OnetrustActiveGroups === 'string' &&
                window.OnetrustActiveGroups.includes(window.requiredFunctinalCookieCategory)) {
                var expiration = new Date();
                expiration.setFullYear(expiration.getFullYear() + 1);
                document.cookie = window.preferredLanguageCookieName + '=' + language + '; path=/; expires=' + expiration.toUTCString();
            }
        } else {
            // Clear the cookie to allow fresh geo-detection on next visit
            document.cookie = window.preferredLanguageCookieName + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
        }
    },

    getLanguageFromHref: function (href) {
        try {
            var a = document.createElement('a');
            a.href = href;
            var path = a.pathname;
            if (path.charAt(0) !== '/') path = '/' + path;
            var parts = path.split('/');
            // parts[0] is empty (before first /), parts[1] is the language segment
            return parts[1] || null;
        } catch (e) {
            return null;
        }
    },

    openSelector: function () {
        var self = this;
        if (self.exists()) {
            window.requestAnimationFrame(function () {
                $(document).trigger('hoya:openedSiteSelector'); // trigger event that other objects can listen to
                self.setScrollbarOffsets();
                self.siteSelectorElement.scrollTop(0);
                $('body').addClass(self.opts.openSelectorClass);
            });
        }
    },

    closeSelector: function () {
        var self = this;
        self.removeScrollbarOffsets();

        window.requestAnimationFrame(function () {
            $(document).trigger('hoya:closedSiteSelector'); // trigger event that other objects can listen to
            $('body').removeClass(self.opts.openSelectorClass);
        });

        self.setCookie();
    },

    setScrollbarOffsets: function () {
        var scrollbarWidth = window.Helpers.getScrollBarWidth();

        // Add scrollbar width to navbar to prevent jump
		$('.navbar')
			.find('> div')
			.css('padding-right', scrollbarWidth);
        $('.navbar-heading > span').css('padding-right', scrollbarWidth);
        $('#main').css('padding-right', scrollbarWidth);
        $('.sticky-footer__inner').css('padding-right', scrollbarWidth);

        //$('.site-selector-overlay__inner').css('padding-left', scrollbarWidth);
        $('.site-selector-overlay__close').css('right', scrollbarWidth);
    },

    removeScrollbarOffsets: function () {
        if (!$('body').hasClass('menu-expanded')) {
            // Reset scrollbar width compensation in navbar
			$('.navbar')
				.find('> div')
				.removeAttr('style'); // Remove style attributes
            $('.navbar-heading > span').removeAttr('style');
            $('#main').removeAttr('style');
            $('.sticky-footer__inner').removeAttr('style');
        }

        //$('.sticky-footer__inner').removeAttr('style');
        $('.site-selector-overlay__close').removeAttr('style');
    },

    expandLangNav: function ($el) {
        var self = this,
            $wrap = $el.find('> div');

        this.collapseAllLangNav(); // collapse all other

        $wrap.removeAttr('style');

        //var height = $el.height() + parseInt($wrap.find('> a').css('padding-top').replace('px', ''), 10) + parseInt($wrap.find('> a').css('padding-bottom').replace('px', ''), 10) - 2;
        var height = $el.find('.country__languages').height();

        $wrap.height($wrap.height() + height);

        $el.addClass(self.opts.langExpandClass);

        $('body').on('click', function () {
            self.collapseLangNav($el);
        });
    },

    collapseLangNav: function ($el) {
        var $wrap = $el.find('> div');
        $wrap.removeAttr('style');
        $el.removeClass(this.opts.langExpandClass);

        $('body').off('click');
    },

    collapseAllLangNav: function () {
        var self = this;

		$('.region-block__country--multi-lang.' + this.opts.langExpandClass).each(
			function() {
            self.collapseLangNav($(this));
			}
		);
    },

    // Set the site selector dismiss parameter on all nav links if in HubSpot page
    updateNavLinks: function () {
        if (window.Helpers.inHubSpotPage()) {
            var self = this,
                selectors = self.opts.comLinkSelectors;

            $(selectors).each(function () {
                if ($(this).attr('href') !== '#' && $(this).attr('href') !== '') {
                    var url = $(this).attr('href');

                    if (url.indexOf('?') === -1) {
                        url += '?' + self.opts.cDismissParamName + '=1';
					} else if (
						url.indexOf('?' + self.opts.cDismissParamName + '=1') === -1 &&
						url.indexOf('&' + self.opts.cDismissParamName + '=1') === -1
					) {
                        url += '&' + self.opts.cDismissParamName + '=1';
                    }

                    $(this).attr('href', url);
                }
            });
        }
	},
};
